import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { ImportClassesDto, ImportClassesResponse } from '../model/recital';

export interface ImportClassesParams {
  recitalId: string;
  data: ImportClassesDto;
}

export const importClassesAPI = async ({
  recitalId,
  data,
}: ImportClassesParams) => {
  const response = await baseAPI.post<ImportClassesResponse>(
    `/recitals/${recitalId}/import-classes`,
    data,
  );
  return response.data;
};

export const useImportClassesMutation = () => {
  return useMutation({
    mutationFn: async (params: ImportClassesParams) => {
      return await importClassesAPI(params);
    },
    onSuccess: (_, variables) => {
      // Invalidate recital queries to refresh data
      void queryClient.invalidateQueries({
        queryKey: [KEYS.RECITALS, variables.recitalId],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.SHOWS, variables.recitalId],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PERFORMANCES],
      });
      void queryClient.invalidateQueries({
        predicate: (query) =>
          query.queryKey[0] === KEYS.ACTS ||
          query.queryKey[0] === variables.data.actId,
      });
    },
  });
};
